import { NovaPluginIds } from "panels/controls/PluginAccessPanel/constants"
import { usePluginSampleData } from "../usePluginSampleData"
import { TryAddOnItem } from "./TryAddOnItem"

export const TryAddOnItemVideo = () => {
    const plugin = usePluginSampleData(NovaPluginIds.Video)
    return <TryAddOnItem plugin={plugin} />
}
